// extracted by mini-css-extract-plugin
export var active = "styles-module--active--8b1b2";
export var bottomContent = "styles-module--bottomContent--19982";
export var bottomContentContainer = "styles-module--bottomContentContainer--84c14";
export var profile = "styles-module--profile--fbcf3";
export var showRight = "styles-module--showRight--0264a";
export var topProfiles = "styles-module--topProfiles--29907";